function ContactModal() {
    this.trigger = document.querySelector('.jsTriggerContactModal');
    this.modal = document.querySelector('.jsModalContact');
    this.modalInner = this.modal.querySelector('.jsModalInner');

    this.trigger.addEventListener('click', e => {
        e.preventDefault();
        this.show();
    });

    this.modal.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) {
            e.preventDefault();
            this.hide();
        }
    });
};

ContactModal.prototype.show = function() {
    new TimelineMax()
        .set(this.modal, { display: 'flex', opacity: 0 })
        .set(this.modalInner, { y: 30, opacity: 0 })
        
        .to(this.modal, 0.5, { opacity: 1, ease: Power2.easeInOut })
        .to(this.modalInner, 0.5, { y: 0, opacity: 1, ease: Power2.easeOut })
    ;
};

ContactModal.prototype.hide = function() {
    new TimelineMax()
        .to(this.modalInner, 0.5, { y: 30, opacity: 0, ease: Power2.easeInOut })
        .to(this.modal, 0.5, { opacity: 0, ease: Power2.easeInOut })
        .set(this.modal, { clearProps: 'all' })
    ;
};